export function downloadFile(blob, fileName): void {
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
